import { FC110 } from '../../services/scApi';

/**
 * Build an unsaved SC draft from a loaded business record.
 *
 * This deliberately clears every document identity/status/audit field while
 * retaining business inputs. Persistence remains the responsibility of the
 * existing SC create API and its normal validations.
 */
export const buildSCAcceptanceDraft = (
  source: FC110,
  today = new Date().toISOString().slice(0, 10),
): FC110 => ({
  ...source,
  fc110_01: '',
  fc110_11: today,
  fc110_51: 'N',
  fc110_53: '',
  fc110_71: '',
  fc110_90: 0,
  fc110_91: '',
  details: (source.details || []).map((detail, detailIndex) => ({
    ...detail,
    fc111_01: '',
    fc111_02: detailIndex + 1,
    expenses: (detail.expenses || []).map((row, rowIndex) => ({
      ...row,
      fc112_01: '',
      fc112_02: detailIndex + 1,
      fc112_03: rowIndex + 1,
    })),
    materials: (detail.materials || []).map((row, rowIndex) => ({
      ...row,
      fc113_01: '',
      fc113_02: detailIndex + 1,
      fc113_03: rowIndex + 1,
    })),
    commissions: (detail.commissions || []).map((row, rowIndex) => ({
      ...row,
      fc114_01: '',
      fc114_02: detailIndex + 1,
      fc114_03: rowIndex + 1,
    })),
    colors: (detail.colors || []).map((row, rowIndex) => ({
      ...row,
      fc115_01: '',
      fc115_02: detailIndex + 1,
      fc115_03: rowIndex + 1,
    })),
    inspections: (detail.inspections || []).map((row, rowIndex) => ({
      ...row,
      fc116_01: '',
      fc116_02: detailIndex + 1,
      fc116_03: rowIndex + 1,
    })),
    accessories: (detail.accessories || []).map((row, rowIndex) => ({
      ...row,
      fc117_01: '',
      fc117_02: detailIndex + 1,
      fc117_03: rowIndex + 1,
    })),
  })),
  shipping_marks: (source.shipping_marks || []).map((row, index) => ({
    ...row,
    fc118_01: '',
    fc118_02: index + 1,
  })),
});
